module.exports = __webpack_public_path__ + "static/media/link.b6f6a8ef.svg";